'use strict';

function UserEnterDirective() {
  return {
    restrict: 'A',
    link: function(scope, elem, attrs) {
      elem.on('keydown keypress', function(e) {
        if(e.which === 13) {
          scope.$apply(attrs.userEnter);
          e.preventDefault();
        }
      });
    }
  };
}

angular.module('dokiv')
  .directive('userEnter', UserEnterDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/UserEnterDirective.js
// module id = 255
// module chunks = 0